var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main has-footer bg-gray"},[_c('div',{staticClass:"wrap"},[_c('task-list',{attrs:{"state":"1","pageSize":"5"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }